import { iotfBmi } from '@athlisis/shared';

// WHO adult classes: underweight, normal, overweight, obese I, II, III
const CUTOFFS = [18.5, 25, 30, 35, 40];

// 0 below 18.5, 1 below 25, … 5 from 40 up. Read from the BMI as shown, to one decimal,
// so "25.0" is never labelled normal.
export const bmiClass = (bmi) => {
  const shown = Number(bmi.toFixed(1));
  return CUTOFFS.filter(cutoff => shown >= cutoff).length;
};

const number = (value) => parseFloat(String(value ?? '').replace(',', '.'));

// The children's BMI tool: age in years and months (either may be blank), height in cm,
// weight in kg. Null when those can't be a child's. No grade under 2; past 18 the IOTF
// lines are the adult cut-offs.
export const kidsBmi = ({ sex, years, months, height, weight }) => {
  const [y, m, cm, kg] = [years, months, height, weight].map(number);
  if ((Number.isNaN(y) && Number.isNaN(m)) || y < 0 || m < 0) return null;
  if (!(cm >= 40 && cm <= 250 && kg >= 1 && kg <= 300)) return null;
  const age = (y || 0) + (m || 0) / 12;
  const bmi = kg / (cm / 100) ** 2;
  if (age < 2) return { bmi: Number(bmi.toFixed(1)), category: null };
  const { bmi: shown, category } = iotfBmi(sex, Math.min(age, 18), bmi);
  return { bmi: shown, category };
};
